 
function TeamCard(probs) {

    const social = JSON.parse(probs.social);

    

    return ( 
       <>
        <div className="col-lg-3 col-md-6 mb-4">
              <div className="team-card text-center">
                <img src={probs.image} alt={probs.namelastname} className="team-image" />
                <h4>{probs.namelastname}</h4>
                <p>{probs.job}</p>
                <div className="social-icons">

                    {Array.isArray(social) && social.map((data,index)=>{
                      return <a href={data.link} className="social-icon"><i className={data.icon} /></a>
                  })}

                   
                </div>
              </div>
            </div>
    </> 
 ); 

}

export default TeamCard;